import { ButtonDialog } from '@autopass-web/mochi-component';

interface PaymentTicketPriceSessionTimeoutDialogProps {
  isOpen: boolean;
  onButtonClick: () => void;
}

export const PaymentTicketPriceSessionTimeoutDialog = ({
  isOpen,
  onButtonClick,
}: PaymentTicketPriceSessionTimeoutDialogProps) => (
  <ButtonDialog
    show={isOpen}
    title="已超過最晚離場時間"
    message="很抱歉！目前時間已超過最晚離場時間，付款金額已變更，請更新付款資訊後，再次確認付款。"
    buttonList={[
      {
        theme: 'positive',
        content: '再次確認資訊並付款',
        onClick: onButtonClick,
        beLoading: false,
      },
    ]}
  />
);
